
export enum VideoFormat {
    FourByTre = 0,
    SixteenByNine = 1
}